export default {
  'addOA.title': 'OAを追加',
  'addOA.button.text': '友達追加でクーポンをゲット！',
  'addOA.content.text': '公式アカウントを友達追加すると、このクーポンを受け取れ、さらにお得な情報や特典のお知らせも届きます。',
} as Record<string, string>;